import {GetNeighborhoodsDentalGuide} from 'domain/usecases';
import {RemoteGetNeighborhoodsDentalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetNeighborhoodsDentalGuide = (): GetNeighborhoodsDentalGuide =>
	new RemoteGetNeighborhoodsDentalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.odontoGuideNeighborhoods),
		makeAuthorizeHttpClientDecorator(),
	);
